// oxlint-disable-next-line no-restricted-imports -- Legacy table migration/demo — do not copy into new code.
import { GridTableRow } from "@design-system/Tables/GridTable/GridTable";
import styles from "./Reconciliation.module.scss";

export const ReconciliationEmptyRow: React.FC = () => (
    <GridTableRow columnBorders>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div className={styles.actionsCell}>&nbsp;</div>
    </GridTableRow>
);
